/**
 * Memoire courte entre « ta session vient d'expirer » et l'ecran de connexion.
 *
 * L'intercepteur d'authentification vide le stockage puis recharge la page vers
 * /signin. Sans ce relais, l'utilisateur atterrit sur un formulaire de
 * connexion sans savoir pourquoi il a ete ejecte — il croit a une panne.
 *
 * sessionStorage plutot que localStorage : le drapeau ne concerne que cet
 * onglet et disparait de lui-meme a sa fermeture. Il ne doit surtout pas
 * ressurgir a la prochaine visite.
 *
 * Tout est garde par try/catch : en navigation privee, certains navigateurs
 * font LEVER l'acces au stockage. Un message d'information ne vaut pas de
 * casser la page de connexion.
 */
const CLE = 'bsr:session-expiree';

/**
 * Reponse retenue pour la duree du chargement de page.
 *
 * React.StrictMode appelle DEUX FOIS l'initialiseur d'un useState en
 * developpement : sans cette memoire, le premier appel consommait le drapeau et
 * le second renvoyait false — le message n'aurait jamais paru en dev, alors
 * qu'il serait apparu en production (les builds ne doublent pas les appels).
 * Un defaut qui ne se voit que d'un cote est le pire de tous.
 *
 * La redirection se fait par `window.location.href` : la page est entierement
 * rechargee, donc cette variable repart a zero. « Une seule fois » reste vrai
 * d'une visite a l'autre, ce qui est le sens voulu.
 */
let reponseDeCeChargement = null;

export function markSessionExpired() {
  try {
    sessionStorage.setItem(CLE, '1');
  } catch {
    /* stockage indisponible : on se passe du message */
  }
}

/** Lit le drapeau ET l'efface : le message ne doit s'afficher qu'une visite. */
export function consumeSessionExpired() {
  if (reponseDeCeChargement !== null) return reponseDeCeChargement;
  try {
    const pose = sessionStorage.getItem(CLE) === '1';
    if (pose) sessionStorage.removeItem(CLE);
    reponseDeCeChargement = pose;
    return pose;
  } catch {
    reponseDeCeChargement = false;
    return false;
  }
}

/** Reservé aux tests : repartir comme au chargement d'une page. */
export function __resetSessionExpiryCache() {
  reponseDeCeChargement = null;
}
